import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Question } from '@core/models/question.model';

@Component({
  selector: 'app-multiple-choice',
  templateUrl: './multiple-choice.component.html',
  styleUrls: ['./multiple-choice.component.css'],
})
export class MultipleChoiceComponent {
  @Input() isMissing = false;
  @Input() question!: Question;
  @Input() index!: number;
  @Output() answerSelected = new EventEmitter<{
    questionUuid: string;
    answerValue: string | { multiple: string; confidence: string };
  }>();

  selectedAnswer: string | null = null;
  confidenceLevel: string | null = null;

  handleSelection(answerUuid: string): void {
    this.selectedAnswer = answerUuid;
    this.emitAnswer();
  }

  handleConfidenceChange(level: string): void {
    this.confidenceLevel = level;
    this.emitAnswer();
  }

  private emitAnswer(): void {
    if (this.selectedAnswer) {
      if (this.question.is_confidence && this.confidenceLevel) {
        this.answerSelected.emit({
          questionUuid: this.question.uuid,
          answerValue: {
            multiple: this.selectedAnswer,
            confidence: this.confidenceLevel,
          },
        });
      } else {
        this.answerSelected.emit({
          questionUuid: this.question.uuid,
          answerValue: this.selectedAnswer,
        });
      }
    }
  }

  get questionHtml(): string {
    const html = this.question.question || '';
    if (!this.question.is_required) {
      return html;
    }
    const marker = ' <span style="color:#dc2626">*</span>';
    const lastCloseTagIndex = html.toLowerCase().lastIndexOf('</p>');
    if (lastCloseTagIndex === -1) {
      return html + marker;
    }
    return html.slice(0, lastCloseTagIndex) + marker + html.slice(lastCloseTagIndex);
  }
}
